module.exports = __webpack_public_path__ + "img/cover-6.028c901f.jpg";